<template>
  <el-dialog
    :visible.sync="show"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    title="['新增','编辑'][params.type]"
    width="800px"
    class="g-big-dialog"
  >
    弹窗demo
    <div
      slot="footer"
      class="dialog-footer g-flex g-flex-fe"
    >
      <el-button @click="handleCancel">取消</el-button>
      <el-button
        type="primary"
        @click="hanldeSure"
      >确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import throttle from '@/mixins/throttle.js';

  const config = {
    name: 'popup-demo',
    watch: {
      show(v) {
        if (!v) {
          this.$emit('destory');
        }
      }
    },
    computed: {

    },
    mixins: [throttle],
    data() {
      return {
        show: false
      };
    },
    methods: {
      handleCancel() {
        this.$emit('close');
      },
      hanldeSure() {
        this.throttle(() => {
          this.$emit('sure');
        });
      }
    }
  };
  export default config;

</script>

<style scoped lang='scss'>
</style>



// WEBPACK FOOTER //
// src/views/demo/add.vue